import { useAuth0 } from '@auth0/auth0-react';

export const useAuthenticatedUser = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const getUserId = () => {
    if (!isAuthenticated || !user) {
      return null;
    }
    
    // Use Auth0 user sub (subject) as the unique user ID
    return user.sub || null;
  };

  const getUserInfo = () => {
    if (!isAuthenticated || !user) {
      return null;
    }

    return {
      id: user.sub,
      email: user.email,
      name: user.name,
      picture: user.picture,
      emailVerified: user.email_verified
    };
  };

  const getAccessToken = async () => {
    if (!isAuthenticated) {
      return null;
    }

    try {
      return await getAccessTokenSilently();
    } catch (error) {
      console.error('Error getting access token:', error);
      return null;
    }
  };

  return {
    getUserId,
    getUserInfo,
    getAccessToken,
    isAuthenticated,
    user
  };
};